import React, { useEffect } from "react";
import WhyChooseSection from "../components/home/WhyChooseSection";
import { setPageMeta } from "../utils/seo";

const WhyChooseCynos = () => {
  useEffect(() => {
    setPageMeta({
      title: "Why Choose Cynos? | Premium Oversized Streetwear India",
      description: "Learn why Cynos is built for premium oversized T-shirts, Indian streetwear fits, secure checkout, COD, and daily comfort.",
      canonical: `${window.location.origin}/why-choose-cynos`,
      og: {
        type: "website",
        title: "Why Choose Cynos?",
        description: "Premium oversized streetwear, made for Indian youth with secure checkout and quality-focused drops.",
        url: `${window.location.origin}/why-choose-cynos`,
        site_name: "Cynos",
      },
    });
  }, []);

  return (
    <main className="pt-16 md:pt-20" data-testid="why-choose-cynos-page">
      <header className="px-4 pt-10 md:px-8 lg:px-12">
        <h1 className="font-anton text-5xl uppercase leading-none md:text-7xl">Why Choose Cynos?</h1>
      </header>
      <WhyChooseSection />
    </main>
  );
};

export default WhyChooseCynos;
